import { menuOptions } from "./list";
import MenuBasic from "./MenuBasic";

const Menu = () => {
  return <MenuBasic options={menuOptions} />;
};

export default Menu;
